/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
  Grid,
  Row,
  Column,
  Keyboard,
  Button,
  SelectorButton,
  Heading,
  Form,
  FormInput,
  cls,
  HeaderCompound
} from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_COLOMBIA_GATE, GETWAY_CLAROCOLOMBIA } from '../utils/constants';
import {
  showModal,
  AAF_MODAL_SUCCESS,
  AAF_MODAL_DOCUMENT_TYPE,
} from '../../actions/modal';
import { apiPaywayConfirm, onPaymetSuccess, showError, getWorkflow, setInitialFocus, onFocusMultipleElements, handleTypeModal, redirectPlayerOneClic, isModalHide } from '../utils/Utils';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import Assets from '../../requests/apa/Asset';
import Device from '../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Spinner from '../../components/Spinner';
import Utils from 'src/utils/Utils';

import './_styles.scss';

interface IColombiaGateState {
  form: {
    document: string;
    account: string;
    documentType: string;
  };
  errorFromBackendDocumentType: string;
  errorFromBackendDocument: string;
  errorFromBackendAccount: string;
  valid: boolean;
  showTooltipSuccess: boolean;
  pbi: any;
  worflowstart: any;
  selectedPaymentMethod: string;
  type: number;
  isLoading: boolean;
  activeElement: string;
  element: any;
}

class PaymentGate extends Component<RouteComponentProps, IColombiaGateState> {
  public textNext: string = Translator.get('hubfijogate_access_option_button_next', 'SIGUIENTE');
  public textDocumentType: string = Translator.get(
    'hubfijogate_documentType_placeHolder_label',
    'Tipo de documento'
  );
  private isValidForm: boolean;
  public textCancel: string = Translator.get(
    'hubfijogate_access_option_button_cancel',
    'CANCELAR'
  );
  public titleForm: string = Translator.get(
    'hubfijogate_access_title_label',
    'Factura Claro Hogar'
  );

  public documentOptions: {option:string, value:string}[] = [];
  public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
  private from: string = '';

  constructor(props: RouteComponentProps) {
    super(props);
    const { location: { state = {} } = {} } = props || {};
    this.from = state?.from;
    this.state = {
      form: {
        document: '',
        account: '',
        documentType: '',
      },
      errorFromBackendDocumentType: '',
      errorFromBackendDocument: '',
      errorFromBackendAccount: '',
      valid: false,
      showTooltipSuccess: false,
      pbi: {},
      worflowstart: {},
      selectedPaymentMethod: '',
      type: 0,
      isLoading: true,
      activeElement: '',
      element: ''
    };
  }

  public componentDidMount(): void {
    document && document.removeEventListener('keydown', this.onKeyPress, true);
    document && document.addEventListener('keydown', this.onKeyPress, true);
    const {
      location: {
        state: {
          type = undefined,
          pbi = undefined,
          worflowstart = undefined,
          method: selectedPaymentMethod = GETWAY_CLAROCOLOMBIA} = {},
      },
    } = this.props;
    if (pbi && worflowstart && type) {
      this.setState({ pbi, worflowstart, selectedPaymentMethod, type, valid: true , isLoading:false});
    }
    if (isModalHide()) {
      setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
    }
  }

  public componentWillUnmount(): void {
    document && document.removeEventListener('keydown', this.onKeyPress, true);
  }

  public componentDidUpdate(): void {
    this.onFocus();
  }

  public enterUpHandler = (e: any) => {
    const el: any = e.target;
    if (el.className.includes('aaf_focusable')) {
      this.setState({ element: e.target });
    }
  };

  @autobind
  private handleChange(value: string, type: string, obj: any): void {
    const { form } = this.state;
    const { $form: { activeField } } = obj['context'];
    this.isValidForm = value !== '';
    this.setState({
      activeElement: activeField,
      form: { ...form, [type]: value } ,
      errorFromBackendDocument: '',
      errorFromBackendAccount: '',
      errorFromBackendDocumentType: ''} as IColombiaGateState);
  }

  @autobind
  private validForm(params: {document: string, account: string, documentType: string}): boolean{
    const {document, account, documentType} = params;

    if (!documentType || documentType.trim() === ''){
      this.setState({ errorFromBackendDocumentType: Translator.get('form_tooltip_empty_label_validation'),
        isLoading: false });
      return false;
    }

    if (!document || document.trim() === ''){
      this.setState({ errorFromBackendDocument: Translator.get('form_tooltip_empty_label_validation') ,
        isLoading: false});
      return false;
    }

    if (!account || account.trim() === ''){
      this.setState({ errorFromBackendAccount: Translator.get('form_tooltip_empty_label_validation') ,
        isLoading: false});
      return false;
    }


    return true;
  }

  private handleSubmit = (): void => {
    this.setState({isLoading:true });

    const {
      worflowstart,
      pbi,
      pbi: { isSubscription },
      selectedPaymentMethod,
      form: { document, account, documentType }
    } = this.state;

    if (!this.validForm({
      document,
      account,
      documentType})){
      return;
    }

    let { valid, showTooltipSuccess } = this.state;
    const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
    let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: any) => this.redirectVCard(resp);

    valid = true;
    showTooltipSuccess = false;
    apiPaywayConfirm({
      pbi,
      wfs,
      formParams: {
        document,
        account,
        document_type: documentType
      }
    })
      .then((resp) => {
        onPaymetSuccess(resp, pbi, wfs, selectedPaymentMethod, cb);
        this.setState({ valid, showTooltipSuccess, isLoading:false });

      })
      .catch((err) => {
        showError(err);
        this.setState({ valid, showTooltipSuccess, isLoading:false, form: {
            document: '',
            account: '',
            documentType: '',
          } });
      });
  };

  private getDocumentTypeString = (documentId: any): string => {
    const document = this.documentOptions.find((m) => {
      return m.value === documentId;
    });
    return document ? document.option : '';
  }

  @autobind
  private handleShowDocument(): void {
    const { showModal } = this.props;
    this.documentOptions = this.parseDocuments(Translator.get('cuenta_lista_tipo_documento'));
    const modal = {
      modalType: AAF_MODAL_DOCUMENT_TYPE,
      modalProps: {
        documents: this.documentOptions,
        service: (m: any) => {
          this.handleModal(m);
        },
      },
    };
    showModal(modal);
  };

  private parseDocuments(documents: string) {
    const elements = documents.split(',');
    return elements.map((item)=>{
      const value = item.split(':');
      return {
        option: value[1],
        value : value[0]
      }
    })
  }

  private handleModal = (id: any): void => {

    const {form: {document, account }} = this.state

    this.setState({ form: { documentType: id, document, account}, errorFromBackendDocumentType: '', errorFromBackendAccount: '', errorFromBackendDocument : ''  } as IColombiaGateState);
  };

  @autobind
  private showTicket(resp: any, groupId: string, islive: boolean) {
    const { showModal } = this.props;
    const { type, worflowstart: { contentInfo }, pbi, pbi: { producttype, currency, price, family, periodicity, frequency }, selectedPaymentMethod } = this.state;
    const region = DeviceStorage.getItem('region');
    const { response: { end_date: { day = '', month = '', year = '' } = {}, payway_token = '' } = {} } = resp || {};
    const payDate = `${day} ${month} ${year}`;

    const data = {
      pbi,
      total: `${currency}${price}`,
      duration: `${Translator.get(periodicity)}`,
      frequency: frequency,
      days: Translator.get(`bonus_${producttype}`),
      content: Translator.get(`Ticket_Transaccion_TextoDescripcion_${producttype}`, ''),
      payment_method: Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, ''),
      img_largeSub: Assets.get(`${region}_transactional_${family}_poster`, ''),
      img_large: contentInfo?.contentImageMedium,
      providerImage: Assets.get(`transactional_${family}_logo`),
      title: contentInfo?.contentTitle || '',
      type: type,
      from: this.from
    };
    const modal = {
      modalType: AAF_MODAL_SUCCESS,
      modalProps: {
        data: handleTypeModal({ ...data, next_pay: payDate }),
        handlePlay: () => this.from ? this.handleAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
        handleVCard: () => this.handleVCard(groupId)
      }
    };
    showModal(modal);
  }

  private redirectAddon(resp: any): void {
    const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
    const isOneClicFlow = groupId === '' ? false : true;
    const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
    if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
      if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
        const { response: { payway_token = '' } = {} } = resp || {};
        this.handlePlay(groupId, payway_token, islive);
      }
      else {
        // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
        this.showTicket(resp, groupId, islive);
      }
    } else {
      // aplica para plan selector y vcard cuando no hay one clic
      this.showTicket(resp, groupId, islive);
    }
  }

  private redirectVCard(resp?: any): void {
    const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
    const isOneClicFlow = groupId === '' ? false : true;
    const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
    if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
      if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
        setTimeout(() => {
          const { history } = this.props;
          const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
          if (islive) {
              if(nav && nav.home) {
                  history.replace(`/node/${nav.home}`);
              }
          }
          else if (groupId) {
              this.handleVCard(groupId);
          }
      }, 0);
      }
      else {
        // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
        this.showTicket(resp, groupId, islive);
      }
    } else {
      // aplica para plan selector y vcard cuando no hay one clic
      this.showTicket(resp, groupId, islive);
    }
  }

  private handleAddOn(resp: any) {
    const { history, nodes } = this.props;
    const { response: { node_id = '' } = {} } = resp || {};
    let nodeString: string = '';
    const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
    const resultChilds = filterNodes.map((res: any) => {
      const childsValue = res.childs;
      return childsValue;
    });

    for (let index = 0; index < resultChilds.length; index++) {
      const element = resultChilds[index];
      element.map((resId: any) => {
        if (resId.id === node_id) {
          return nodeString = resId.code;
        }
      });
    }

    this.setState({ isLoading: false });
    history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
  }

  @autobind
  private handlePlay(groupId: string, payway_token: string, islive: boolean) {
    if (groupId) {
      redirectPlayerOneClic(groupId, islive, payway_token, () => {
        this.handleVCard(groupId);
      })
    }
  }

  @autobind
  private handleVCard(groupId: string) {
    if (groupId) {
      const { history } = this.props;
      history.replace(`/vcard/${groupId}`);
    }
  }

  private hadleCancel = (): void => {
    const { history } = this.props;
    history.goBack();
  };

  @autobind
  private handleBack(): void {
    const { history } = this.props;
    history.goBack();
  }

  @autobind
  private onKeyPress(e: any): void {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    if (currentKey === 'YELLOW') {
      this.handleBack();
    }
  }

  @autobind
  private onFocus(): void {
    const { element } = this.state;
    let activeDoc: boolean = false;
    let activeAccount: boolean = false;
    const numberElments = document.getElementsByClassName('aaf_focusable');
    if (numberElments.length > 1) {
      activeDoc = true;
      if (element.id === 'account') {
        activeDoc = false;
        activeAccount = true;
      }
    }

    onFocusMultipleElements([{ id: 'document', activeElement: activeDoc }, { id: 'account', activeElement: activeAccount }]);
  }

  public render(): JSX.Element {
    const {
      form: { documentType, account, document },
      valid,
      errorFromBackendDocument,
      errorFromBackendDocumentType,
      errorFromBackendAccount,
      isLoading
    } = this.state;


    if (isLoading) return <Spinner className={cls(`${PAYMENT_COLOMBIA_GATE}-spinner`)} loadingMessage='' />;
    return (
      <Grid className={Device.getDevice().getPlatform()}>
        <HeaderCompound
          disabled
          align='right'
          onClick={this.handleBack}
          textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
          icon={`${Assets.get('top_head_option_back')}`}
        />
        <Row>
          <Column lg={12}>
            <Heading size={2} className={cls(`${PAYMENT_COLOMBIA_GATE}-title`)}>
              {this.from ? Translator.get('top_head_step_3_label', 'PASO 3 DE 3') : ''}
            </Heading>
          </Column>
        </Row>
        <Row>
          <Form id="payment-clarocolombiagate-form">
            <Column lg={6} className={cls(`${PAYMENT_COLOMBIA_GATE}-column-keyboard`)}>
              <Keyboard id="Keyboard" onFocus={this.onFocus} />
            </Column>
            <Column lg={6} className={cls(`${PAYMENT_COLOMBIA_GATE}-column-inputs`)}>
              <Row className={cls(`${PAYMENT_COLOMBIA_GATE}-row-inputs`)}>
                <Column lg={12}>
                  <Heading
                    size={1}
                    className={cls(`${PAYMENT_COLOMBIA_GATE}-title-form`)}
                  >
                    {this.titleForm}
                  </Heading>
                </Column>
                <Column
                  lg={12}
                  className={cls(`${PAYMENT_COLOMBIA_GATE}-column-next`)}
                >
                  <SelectorButton
                    type="button"
                    className={cls(
                      `focusable`,
                      `${PAYMENT_COLOMBIA_GATE}-button-document`
                    )}
                    onClick={this.handleShowDocument}
                    errorFromBackend={errorFromBackendDocumentType}

                  >
                    {documentType ? this.getDocumentTypeString(documentType) : this.textDocumentType}
                    <i className="icon-arrow-down payment" />
                  </SelectorButton>
                </Column>
                <Row className={cls(`${PAYMENT_COLOMBIA_GATE}-column-input`)}>
                  <FormInput
                    focusWhenMount
                    type="text"
                    name="document"
                    id='document'
                    placeholder="Número de tu documento"
                    onChange={(e, obj) => this.handleChange(e, 'document', obj)}
                    errorFromBackend={errorFromBackendDocument}
                  />
                </Row>
                <Row className={cls(`${PAYMENT_COLOMBIA_GATE}-column-input`)}>
                  <FormInput
                    type="text"
                    name="account"
                    id='account'
                    placeholder="Número de cuenta Soluciones Fijas"
                    onChange={(e, obj) => this.handleChange(e, 'account', obj)}
                    errorFromBackend={errorFromBackendAccount}
                  />
                </Row>
                <Column
                  lg={12}
                  className={cls(`${PAYMENT_COLOMBIA_GATE}-column-next`)}
                >
                  <Button
                    activate
                    type="button"
                    variant="primary"
                    disabled={!this.isValidForm}
                    className={cls(
                      `focusable`,
                      `${PAYMENT_COLOMBIA_GATE}-button-next`
                    )}
                    onClick={this.handleSubmit}
                    block
                    onFocus={this.onFocus}
                  >
                    {this.textNext}
                  </Button>
                </Column>
                <Column
                  lg={12}
                  className={cls(`${PAYMENT_COLOMBIA_GATE}-column-next`)}
                >
                  <Button
                    activate
                    type="button"
                    className={cls(
                      `focusable`,
                      `${PAYMENT_COLOMBIA_GATE}-button-cancel`
                    )}
                    onClick={this.hadleCancel}
                    block
                    onFocus={this.onFocus}
                  >
                    {this.textCancel}
                  </Button>
                </Column>
              </Row>
            </Column>
          </Form>
        </Row>
      </Grid>
    );
  }
}

const mapDispatchToProps = {
  showModal,
};

export default connect(null, mapDispatchToProps)(PaymentGate);



// WEBPACK FOOTER //
// ./src/payments/ClaroColombiaGate/index.tsx